import * as React from 'react';
const ConstructorsAdditionalJobIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={90}
    height={90}
    fill="none"
    viewBox="0 0 96 96"
    {...props}
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H92C94.2091 0 96 1.79086 96 4V92C96 94.2091 94.2091 96 92 96H4C1.79086 96 0 94.2091 0 92V4Z"
      fill="url(#paint0_linear_588_3322)"
    />
    <path
      d="M40 48H50M40 56H50M40 64H50M58 66H64C67.3137 66 70 63.3137 70 60V32.2886C70 29.262 67.7467 26.6937 64.7304 26.4434C63.735 26.3608 62.7364 26.2896 61.7346 26.2298M46.2654 26.2298C46.0929 26.7894 46 27.3838 46 28C46 29.1046 46.8954 30 48 30H60C61.1046 30 62 29.1046 62 28C62 27.3838 61.9071 26.7894 61.7346 26.2298M46.2654 26.2298C47.0207 23.7802 49.3024 22 52 22H56C58.6976 22 60.9793 23.7802 61.7346 26.2298M46.2654 26.2298C45.2636 26.2896 44.265 26.3608 43.2696 26.4434C40.2533 26.6937 38 29.262 38 32.2886V38M38 38H29C27.3431 38 26 39.3431 26 41V71C26 72.6569 27.3431 74 29 74H55C56.6569 74 58 72.6569 58 71V41C58 39.3431 56.6569 38 55 38H38ZM34 48H34.02V48.02H34V48ZM34 56H34.02V56.02H34V56ZM34 64H34.02V64.02H34V64Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_588_3322"
        x1="48"
        y1="0"
        x2="48"
        y2="96"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ECE852" />
        <stop offset="1" stopColor="#FCCD2A" />
      </linearGradient>
    </defs>
  </svg>
);
export default ConstructorsAdditionalJobIcon;
